import { render } from "./Chips.vue?vue&type=template&id=bfc04ffa&ts=true"
import script from "./Chips.vue?vue&type=script&lang=ts"
export * from "./Chips.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__